import axios from "axios";
import { toast } from "react-toastify";

// Centralized logout function
const handleLogout = () => {
  // Clear all storage
  localStorage.clear();
  sessionStorage.clear();
  
  // Redirect to login page immediately
  window.location.href = "/";
};

export const handleApiCall = async (method = "", url = "", data = {}, token = "") => {
  let axiosConfig = {
    method,
    url: `${process.env.REACT_APP_API}${url}`,
    headers: {
      Authorization: `Bearer ${localStorage?.getItem("sessionToken") || token}`,
    },
  };

  // For FormData, let axios automatically set Content-Type with boundary
  // Don't set Content-Type explicitly for FormData
  if (method !== "get") {
    axiosConfig["data"] = data;
    // If data is FormData, axios will automatically set Content-Type to multipart/form-data
    // We don't need to set it explicitly
  }

  try {
    let response = await axios(axiosConfig);
    return response;
  } catch (error) {
    console.warn(error);

    // Get error message from backend
    const errorMsg = error?.response?.data?.errorMessage || error?.response?.data?.message || error?.response?.data?.error || "Something went wrong!";
    const errorCode = error?.response?.data?.code;
    const statusCode = error?.response?.status;

    // Normalize error message for comparison (case-insensitive)
    const normalizedErrorMsg = errorMsg?.toLowerCase()?.trim();

    // Handle 401 - Unauthorized or session expired
    if (statusCode === 401 || errorCode === 401 || errorCode === "401") {
      // Check if it's a login-related error (Invalid credentials) - don't logout on login page
      if (normalizedErrorMsg === "invalid credentials" || normalizedErrorMsg === "invalid email or password") {
        toast.error(errorMsg);
        return { error: true, message: errorMsg };
      }
      // For all other 401 errors (session expired, unauthorized, etc.)
      toast.error("Your session has expired. Please log in again.");
      handleLogout();
      return { error: true, message: "Session expired" };
    }

    // Handle Unauthorized messages (case-insensitive) regardless of status code
    if (normalizedErrorMsg === "unauthorized" || normalizedErrorMsg.includes("unauthorized")) {
      toast.error("Your session has expired. Please log in again.");
      handleLogout();
      return { error: true, message: "Unauthorized" };
    }

    // Handle 403 - Forbidden (similar to unauthorized)
    if (statusCode === 403 || errorCode === 403 || errorCode === "403") {
      toast.error("Your session has expired. Please log in again.");
      handleLogout();
      return { error: true, message: "Forbidden" };
    }

    // Handle 404 - Token Invalid (only for specific token invalid message)
    if (statusCode === 404 && (normalizedErrorMsg === "your token is invalid!" || normalizedErrorMsg.includes("token is invalid"))) {
      toast.error("Your session has expired. Please log in again.");
      handleLogout();
      return { error: true, message: "Token invalid" };
    }

    // Handle 404 - Admin not found (login error) - don't logout
    if (statusCode === 404 && normalizedErrorMsg === "admin not found") {
      toast.error(errorMsg);
      return { error: true, message: errorMsg };
    }

    // Handle 404 - Something went wrong (logout user)
    if (statusCode === 404 && normalizedErrorMsg === "something went wrong") {
      toast.error("Your session has expired. Please log in again.");
      handleLogout();
      return { error: true, message: "Session expired" };
    }

    // Handle all other errors - show the actual error message from backend
    toast.error(errorMsg);
    console.log(errorMsg);
    return { error: true, message: errorMsg };
  }
};
